<template>
    <div>
        <div v-bind:class="ifLoading" class="loader">
            <TheSpinner />
        </div>
        <div v-if="loading">

            <div class="p-5 pb-3 md:pl-12">
                <the-title parentcolor="orange">
                    <slot slot="de">
                        Spielplan: {{items[0].root.sportart_de}} - {{items[0].root.alter_de}}
                    </slot>
                    <slot slot="en">
                        Shedule: {{items[0].root.sportart_en}} - {{items[0].root.alter_en}}
                    </slot>
                </the-title>
            </div>
            <div class="title-container">
                <!--div class="filters">
                    <span class="filter" v-bind:class="{ active: currentFilter === 'ALL' }" v-on:click="setFilter('ALL')">ALL</span>
                    <span class="filter" v-bind:class="{ active: currentFilter === 'ART' }" v-on:click="setFilter('2')">ART</span>
                    <span class="filter" v-bind:class="{ active: currentFilter === 'WORKSHOPS' }" v-on:click="setFilter('3')">WORKSHOPS</span>
                    <span class="filter" v-bind:class="{ active: currentFilter === 'FUN' }" v-on:click="setFilter('1')">DOODLES</span>
                </div-->
            </div>
            <ul class="mb-5">
                <li :key="sportTeilnehmerItem.ID" v-for="sportTeilnehmerItem in items[1]" class="hidden inline-block uppercase font-extrabold text-primary-red gradientText border-0 border-b-2 border-secondary-grey w-full md:w-2/4 md:text-5xl px-8 md:pl-12 py-6 md:py-12" v-if="sportTeilnehmerItem.name_de">
                    {{sportTeilnehmerItem.ID}}
                    {{sportTeilnehmerItem.name_de}}
                    <!--router-link  v-bind:to="sportartItem.router">
                        <the-language :de="sportartItem.name_de" :en="sportartItem.name_en" />
                    </router-link-->
                </li>
            </ul>
            <ul class="mb-5">
                <li :key="teilnehmerGruppe.ID" v-for="teilnehmerGruppe in items[2]" class="hidden inline-block uppercase font-extrabold text-primary-red  border-0 border-b-2 border-secondary-grey w-full md:w-2/4 md:text-5xl px-8 md:pl-12 py-6 md:py-12" v-if="teilnehmerGruppe.name_de">
                    <pre>
                        {{teilnehmerGruppe.name_de}}
                    </pre>
                    <!--router-link  v-bind:to="sportartItem.router">
                        <the-language :de="sportartItem.name_de" :en="sportartItem.name_en" />
                    </router-link-->
                </li>
            </ul>

            <ul class="mb-5 md:max-w-4xl md:m-auto">
                <li
                        :key="sportartItem.ID"
                        v-for="sportartItem in items[3]"
                        v-if="sportartItem.router"
                        class="inline-block uppercase font-extrabold border-0
                        border-b-2 border-secondary-grey w-full
                        md:text-5xl md:pl-12 py-2 mb-4 pb-4"
                >
                    <div v-if="sportartItem.router">
                        <router-link  v-bind:to="sportartItem.router">
                            <div v-if="sportartItem.sheduletype == 'vorschau'">
                                <div class="px-5 text-center relative flexbox">
                                    <div class="w-full opacity-50 text-left pb-3 md:pb-0 ">
                                        <div class="text-xs bg-primary-orange text-white inline-block p-1 truncate">
                                            <the-language :de="sportartItem.gruppe_name_de" :en="sportartItem.gruppe_name_en" />
                                        </div>
                                    </div>
                                    <div class="gradientText inline-block w-1/2 p-5 vs border-t border-b border-primary-orange md:pl-4">
                                        <div class="flag inline-block md:float-left">
                                            <img v-bind:src="sportartItem.fahne_home">
                                        </div>
                                        <div class="truncate md:text-lg md:pl-4 md:leading-normal">
                                            <the-language :de="sportartItem.home_de" :en="sportartItem.home_en" />
                                        </div>
                                    </div>
                                    <div class="gradientText inline-block w-1/2 p-5 border-t border-b border-primary-orange md:pl-12">
                                        <div class="flag inline-block md:float-right">
                                            <img v-bind:src="sportartItem.fahne_away">
                                        </div>
                                        <div class="truncate md:text-lg md:float-left md:pl-4 md:leading-normal">
                                            <the-language :de="sportartItem.away_de" :en="sportartItem.away_en" />
                                        </div>
                                    </div>
                                </div>
                                <div class="px-5 pt-3 text-xs text-secondary-text">
                                    <p>
                                        <the-language :de="sportartItem.date_de" :en="sportartItem.date_en" />
                                    </p>
                                    <p class="pt-3">
                                        <the-language :de="sportartItem.sportplatz_de" :en="sportartItem.sportplatz_en" />
                                    </p>
                                </div>
                            </div>
                            <div v-if="sportartItem.sheduletype == 'ergebnis'">
                                <div class="px-5 text-center relative flexbox ergebnis">
                                    <div class="w-full opacity-50 text-left pb-3 md:pb-0 ">
                                        <div class="text-xs bg-primary-orange text-white inline-block p-1 truncate">
                                            <the-language :de="sportartItem.gruppe_name_de" :en="sportartItem.gruppe_name_en" />
                                        </div>
                                    </div>
                                    <div class="gradientText inline-block w-1/2 p-5 vs border-t border-b border-primary-orange md:pl-4">
                                        <div class="flag inline-block md:float-left">
                                            <img v-bind:src="sportartItem.fahne_home">
                                        </div>
                                        <div class="truncate md:text-lg md:pl-4 md:leading-normal">
                                            <div class="text-5xl">{{sportartItem.home_tore}}</div>
                                            <the-language :de="sportartItem.home_de" :en="sportartItem.home_en" />
                                        </div>
                                    </div>
                                    <div class="gradientText inline-block w-1/2 p-5 border-t border-b border-primary-orange md:pl-12">
                                        <div class="flag inline-block md:float-right">
                                            <img v-bind:src="sportartItem.fahne_away">
                                        </div>
                                        <div class="truncate md:text-lg md:float-left md:pl-4 md:leading-normal">
                                            <div class="text-5xl">{{sportartItem.away_tore}}</div>
                                            <the-language :de="sportartItem.away_de" :en="sportartItem.away_en" />
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </router-link>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import TheTitle from "../TheTitle";
    import TheLanguage from "../TheLanguage";
    import TheSpinner from "../TheSpinner"
    import TheTextView from "../TheTextView";

    export default {
        name: 'homepage',
        components: {
            TheSpinner,
            TheLanguage,
            TheTitle,
            TheTextView
        },
        data(){
            return{
                currentFilter: 'ALL',
                loading: false,
                items: []
            }
        },
        created: function(){
            const baseURI = 'https://api.pgsi2020.de/api/file/spielplan/'+this.$route.params.id+'.json'
            this.$http.get(baseURI)
                .then((result) => {
                    this.items = result.data,
                        this.loading = true
                })
        },
        computed: {
            ifLoading() {
                if(this.loading){
                    return 'loaded';
                }else{
                    return 'isLoading';
                }
            }
        }
    }
</script>

<style lang="scss">
    .flag{
        width: 20%;
        padding-bottom: 10px;
        @screen md{
            width: 30px;
            padding-bottom: 0;
        }
    }
    .vs{
        border-right: 1px solid #f8b234;
        &:after{
            color: #368dc7;
            content: 'vs';
            -webkit-text-fill-color: #368dc7;
            border: 2px solid #f8b234;
            background: #FFF;
            border-radius: 100%;
            padding: 0;
            position: absolute;
            font-size: 30px;
            line-height: 50px;
            top: 50%;
            font-size: 1rem;
            width: 40px;
            height: 40px;
            line-height: 2.5;
            @screen md{
                font-size: 1.2rem;
                width: 50px;
                height: 50px;
                .ergebnis &{
                    bottom: 50px;
                }
                bottom: 9px;
                top: inherit;
            }
            font-weight: lighter;
            margin-top: -10px;
            left: 50%;
            margin-left: -25px;
        }
    }
    .flexbox{
        display: flex;
        flex-wrap: wrap;
    }
</style>
